import Icon from 'src/components/Icon/Icon.component';
import styled from 'styled-components';

export const IconSearch = styled(Icon)`
  position: absolute;
  right: 1rem;
  top: 1.25rem;
`;
